import { Part, UsedIn } from "@domain/product/models/ProductComponent";
import { PartDTO, UsedInDTO } from "../dto/ProductComponentDTO";
import { ProductMapper } from "./ProductMapper";

export class ProductComponentMapper {
  static toPartModel(dto: PartDTO): Part {
    return {
      part: ProductMapper.toModel(dto.part),
      quantity: dto.quantity,
    };
  }

  static toUsedInModel(dto: UsedInDTO): UsedIn {
    return {
      usedIn: ProductMapper.toModel(dto.usedInProduct),
      quantity: dto.quantity,
    };
  }

}
